import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

export function EmailCopy({ email = "info@poseidonmusic.net" }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      toast.success(t("contact.ctaToast"), {
        description: email,
        duration: 2200,
      });
      setTimeout(() => setCopied(false), 1600);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = email;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        setCopied(true);
        toast.success(t("contact.ctaToast"), { description: email });
        setTimeout(() => setCopied(false), 1600);
      } catch {
        toast.error(email);
      }
      document.body.removeChild(ta);
    }
  };

  return (
    <div className="flex flex-col items-start gap-5">
      <a
        href={`mailto:${email}`}
        className="group relative inline-block text-[var(--paper-50)] font-display-en"
        data-testid="email-link"
        aria-label={email}
      >
        <span className="text-4xl sm:text-5xl lg:text-[68px] tracking-[-0.02em] leading-[1.05] gold-shimmer-text font-[700]">
          {email}
        </span>
        <span
          aria-hidden="true"
          className="absolute left-0 -bottom-2 h-[1px] w-full"
          style={{
            background:
              "linear-gradient(90deg, rgba(240,196,90,0) 0%, rgba(240,196,90,0.6) 50%, rgba(240,196,90,0) 100%)",
          }}
        />
      </a>

      <button
        type="button"
        onClick={onCopy}
        data-testid="email-copy-button"
        aria-label={copied ? t("contact.ctaCopied") : t("contact.cta")}
        className={[
          "relative inline-flex items-center gap-2.5 rounded-[12px] px-5 py-3",
          "text-[13px] tracking-[0.12em] uppercase font-mono-brand",
          "bg-[var(--gold-400)] text-[var(--navy-950)] ring-gold",
          "transition-transform duration-200 hover:brightness-[1.04] active:scale-[0.98]",
          "focus-visible:ring-2 focus-visible:ring-[var(--gold-400)] outline-none",
        ].join(" ")}
      >
        {copied ? <Check size={16} /> : <Copy size={16} />}
        <span>{copied ? t("contact.ctaCopied") : t("contact.cta")}</span>
      </button>
    </div>
  );
}
